var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-8 flex items-center justify-between bg-indigo-500 rounded w-full"},[_c('div',{staticClass:"flex items-center"},[_c('icon',{staticClass:"mx-4 flex-shrink-0 w-4 h-4 fill-white",attrs:{"name":"information-outline"}}),_vm._v(" "),_c('div',{staticClass:"py-4 text-white text-sm font-medium"},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }